import { useEffect } from "react";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getDashBoardStore from "../../../stores/dashboard-store";
import { getKhattabatAssignStore } from "../../../stores/khattabat-stores/assign-store";

const KhattabatNewClients = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;
  const { totalUnassignedKhattabatClients, totalUnassignedKhattabatTesters } =
    getDashBoardStore();

  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_NEW_CLIENTS",
      "KHATTABAT_NEW_CLIENTS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("NEW_CLIENTS")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Stack sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            flexWrap="wrap"
            useFlexGap
          >
            <Chip
              variant="outlined"
              label={`${i18n.get("KHATTABAT_ASSIGN_REAL_USERS")}: ${totalUnassignedKhattabatClients.get()}`}
            />
            <Chip
              variant="outlined"
              color="error"
              label={`${i18n.get("KHATTABAT_ASSIGN_TESTER_USERS")}: ${totalUnassignedKhattabatTesters.get()}`}
            />
            <Button
              variant="contained"
              sx={{ ml: "auto" }}
              onClick={() => {
                if (
                  !getKhattabatAssignStore().checkifNewClientsOrTestersAvailable.get()
                ) {
                  return getCorePopUpStore().showAlertMessage(
                    "NO_NEW_CLIENTS_AVAILABLE"
                  );
                }
                getCorePopUpStore().openConfirmationPopUps(
                  "KHATTABAT_CLIENT_ASSIGN_CONFIRMATION_POPUP"
                );
              }}
            >
              {i18n.get("ASSIGN_CLIENT_TO_ME")}
            </Button>
          </Stack>
        </Paper>
      </Stack>
    </ET3PageDiv>
  );
});

export default KhattabatNewClients;
